import { useMutation, useQueryClient } from '@tanstack/react-query';
import { tokenStorage } from '../lib/secureStorage';
import { useAuthContext } from '../contexts/AuthContext';
import { authService } from '../services/apiService';

// Auth Hooks
export const useLogin = () => {
  const { refreshAuth } = useAuthContext();
  return useMutation({
    mutationFn: (credentials: Parameters<typeof authService.login>[0]) =>
      authService.login(credentials),
    onSuccess: (data) => {
      tokenStorage.setAccessToken(data.accessToken);
      tokenStorage.setRefreshToken(data.refreshToken);
      refreshAuth();
    },
  });
};

export const useLogout = () => {
  const queryClient = useQueryClient();
  const { refreshAuth } = useAuthContext();

  return useMutation({
    mutationFn: async () => {
      const refreshToken = tokenStorage.getRefreshToken();
      if (refreshToken) {
        await authService.logout({ refreshToken });
      }
    },
    onSettled: () => {
      tokenStorage.clearTokens();
      queryClient.clear();
      refreshAuth();
    },
  });
};
